import J from "@babel/runtime/helpers/esm/slicedToArray";
import D from "@babel/runtime/helpers/esm/objectWithoutProperties";
import d from "@babel/runtime/helpers/esm/objectSpread2";
import K from "@babel/runtime/helpers/esm/classCallCheck";
import Q from "@babel/runtime/helpers/esm/createClass";
import z from "@babel/runtime/helpers/esm/assertThisInitialized";
import X from "@babel/runtime/helpers/esm/inherits";
import Y from "@babel/runtime/helpers/esm/createSuper";
import S from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as Z } from "@semcore/utils/lib/core/index";
import ee, { sstyled as h, Component as te, assignProps as F } from "@semcore/core";
import i from "react";
import R from "@semcore/tooltip";
import { Box as L } from "@semcore/flex-box";
import { useResizeObserver as ie } from "./useResizeObserver.mjs";
import ne from "@semcore/utils/lib/use/useEnhancedEffect";
import re, { isAdvanceMode as oe } from "@semcore/utils/lib/findComponent";
import N from "@semcore/utils/lib/reactToText";
import W from "@semcore/utils/lib/getOriginChildren";
import j from "@semcore/utils/lib/pick";
import { forkRef as le } from "@semcore/utils/lib/ref";
import { callAllEventHandlers as ae } from "@semcore/utils/lib/assignProps";
var se = ["styles", "Children", "maxLine", "tooltip", "trim", "containerRect", "containerRef", "includeTooltipProps", "children"], de = ["styles", "text", "tooltip", "containerRect", "containerRef", "textRef", "tooltipProps", "children", "advanceMode"], ce = (
  /*__reshadow_css_start__*/
  (Z.insert(
    /*__inner_css_start__*/
    ".___SContainerMiddle_gtb2q_gg_,.___SContainer_gtb2q_gg_,.___SEllipsis_gtb2q_gg_.__middle-mod_gtb2q_gg_,.___SNoTooltipContainer_gtb2q_gg_{display:flex;overflow:hidden}.___SBeginning_gtb2q_gg_,.___SEllipsis_gtb2q_gg_{overflow:hidden;display:inline-block;text-overflow:ellipsis;white-space:pre}.___SEllipsis_gtb2q_gg_.__maxLine_gtb2q_gg_{display:-webkit-box;-webkit-line-clamp:var(--maxLine_gtb2q);-webkit-box-orient:vertical;overflow:hidden;white-space:normal;word-wrap:break-word}.___SContainerMiddle_gtb2q_gg_>:has(.___SBeginning_gtb2q_gg_),.___SContainerMiddle_gtb2q_gg_>:has(.___STail_gtb2q_gg_){display:flex;width:100%}.___STail_gtb2q_gg_{white-space:pre}",
    "gtb2q_gg_"
  ), {
    __SContainer: "___SContainer_gtb2q_gg_",
    __SNoTooltipContainer: "___SNoTooltipContainer_gtb2q_gg_",
    __SContainerMiddle: "___SContainerMiddle_gtb2q_gg_",
    __SBeginning: "___SBeginning_gtb2q_gg_",
    __SEllipsis: "___SEllipsis_gtb2q_gg_",
    "_middle-mod": "__middle-mod_gtb2q_gg_",
    _maxLine: "__maxLine_gtb2q_gg_",
    "--maxLine": "--maxLine_gtb2q",
    __STail: "___STail_gtb2q_gg_"
  })
), pe = ["title", "theme", "strategy", "modifiers", "placement", "interaction", "timeout", "visible", "defaultVisible", "onVisibleChange", "offset", "preventOverflow", "arrow", "flip", "computeStyles", "eventListeners", "onFirstUpdate", "cursorAnchoring"], ge = function(o, l) {
  var t = window.getComputedStyle(o, null), e = document.createElement("temporary-block");
  return e.style.display = t.getPropertyValue("display"), e.style.padding = t.getPropertyValue("padding"), e.style.position = "absolute", e.style.right = "0%", e.style.bottom = "0%", e.style.visibility = "hidden", e.style.fontFamily = t.getPropertyValue("font-family"), e.style.fontSize = t.getPropertyValue("font-size"), e.style.fontWeight = t.getPropertyValue("font-weight"), e.style.lineHeight = t.getPropertyValue("line-height"), e.style.whiteSpace = t.getPropertyValue("white-space"), e.style.wordWrap = t.getPropertyValue("word-wrap"), e.style.fontFeatureSettings = t.getPropertyValue("font-feature-settings"), e.style.fontVariantNumeric = t.getPropertyValue("font-variant-numeric"), e.innerHTML = l ?? o.innerHTML, e;
};
function _e(u, o, l) {
  if (!u) return !1;
  var t = u.getBoundingClientRect(), e = t.height, a = t.width, r = ge(u, l), n = !1;
  if (document.body.appendChild(r), o) {
    r.style.width = "".concat(a, "px");
    var g = r.scrollWidth, s = r.getBoundingClientRect().height;
    (Math.ceil(e) < s || Math.ceil(a) < g) && (n = !0);
  } else
    r.style.whiteSpace = "nowrap", n = Math.ceil(a) < r.getBoundingClientRect().width;
  return document.body.removeChild(r), n;
}
var I = {
  forcedAdvancedMode: !0
}, me = {}, B = /* @__PURE__ */ function(u) {
  X(l, u);
  var o = Y(l);
  function l() {
    var t;
    K(this, l);
    for (var e = arguments.length, a = new Array(e), r = 0; r < e; r++)
      a[r] = arguments[r];
    return t = o.call.apply(o, [this].concat(a)), S(z(t), "state", {
      visible: !1
    }), S(z(t), "textRef", /* @__PURE__ */ i.createRef()), S(z(t), "handlerVisibleChange", function(n) {
      t.setState({
        visible: n && t.showTooltip()
      });
    }), t;
  }
  return Q(l, [{
    key: "showTooltip",
    value: function() {
      var e = this.asProps, a = e.maxLine, r = a === void 0 ? 1 : a, n = e.Children, g = N(W(n));
      return _e(this.textRef.current, r > 1, g);
    }
  }, {
    key: "getContentProps",
    value: function() {
      return {
        ref: this.textRef,
        maxLine: this.asProps.maxLine
      };
    }
  }, {
    key: "getPopperProps",
    value: function() {
      var e = this.asProps, a = e.Children, r = e.includeTooltipProps, n = N(W(a)), g = j(this.asProps, r);
      return d({
        children: n
      }, g);
    }
  }, {
    key: "render",
    value: function() {
      var e, a, r = this.Root, n = R, g = L, s = this.asProps, _ = s.styles, c = s.Children, y = s.maxLine, m = s.tooltip, k = s.trim, M = s.containerRect, E = s.containerRef, A = s.includeTooltipProps;
      s.children;
      var b = D(s, se), T = this.state.visible, q = re(c, [$.Content.displayName]), P = N(q || W(c)), f = oe(c, [$.Content.displayName, $.Popper.displayName]), p = j(this.asProps, A);
      if (p.visible = (a = p.visible) !== null && a !== void 0 ? a : T, p.onVisibleChange = p.onVisibleChange ? ae(p.onVisibleChange, this.handlerVisibleChange) : this.handlerVisibleChange, k === "middle") {
        var C;
        return C = h(_), /* @__PURE__ */ i.createElement(ue, C.cn("EllipsisMiddle", d({
          text: P,
          styles: _,
          tooltip: m,
          containerRect: M,
          containerRef: E,
          textRef: this.textRef,
          tooltipProps: p,
          advanceMode: f
        }, b)), /* @__PURE__ */ i.createElement(c, C.cn("Children", {})));
      }
      if (m) {
        var v;
        return v = h(_), /* @__PURE__ */ i.createElement(n, v.cn("SContainer", d(d({
          interaction: "hover",
          title: f ? void 0 : P
        }, p), f ? I : me)), f ? /* @__PURE__ */ i.createElement(c, v.cn("Children", {})) : /* @__PURE__ */ i.createElement(r, v.cn("SEllipsis", d({
          render: L,
          ref: this.textRef,
          maxLine: y
        }, b)), /* @__PURE__ */ i.createElement(c, v.cn("Children", {}))));
      }
      return e = h(_), /* @__PURE__ */ i.createElement(g, e.cn("SNoTooltipContainer", {}), f ? /* @__PURE__ */ i.createElement(c, e.cn("Children", {})) : /* @__PURE__ */ i.createElement(r, e.cn("SEllipsis", d({
        render: L,
        ref: this.textRef,
        maxLine: y
      }, b)), /* @__PURE__ */ i.createElement(c, e.cn("Children", {}))));
    }
  }]), l;
}(te);
S(B, "displayName", "Ellipsis");
S(B, "style", ce);
S(B, "defaultProps", {
  trim: "end",
  tooltip: !0,
  includeTooltipProps: pe,
  __excludeProps: ["title"]
});
var U = /* @__PURE__ */ i.createContext(null), ue = function(o) {
  var l, t = o.styles, e = o.text, a = o.tooltip, r = o.containerRect, n = o.containerRef, g = o.textRef, s = o.tooltipProps, _ = o.children, c = o.advanceMode, y = D(o, de), m = i.useRef(null), k = i.useState({
    fontSize: "14",
    symbolWidth: 0
  }), M = J(k, 2), E = M[0], A = M[1], b = ie(m, r).width;
  ne(function() {
    var O = (n == null ? void 0 : n.current) || (m == null ? void 0 : m.current);
    if (O) {
      var w = document.createElement("temporary-block");
      w.setAttribute("style", "fontSize: ".concat(E.fontSize, "px")), w.innerHTML = "a", document.body.appendChild(w);
      var G = w.getBoundingClientRect();
      A({
        fontSize: window.getComputedStyle(O, null).getPropertyValue("font-size"),
        symbolWidth: G.width
      }), document.body.removeChild(w);
    }
  }, []);
  var T = "span", q = "span", P = o.tag || L, f = R, p = i.useMemo(function() {
    return Math.round(b / E.symbolWidth);
  }, [b, E.symbolWidth]), C = e.length > p ? "hover" : "none", v = n ?? m, x = i.useMemo(function() {
    return {
      begining: e.substring(0, e.length - p / 2 - 1),
      tail: e.substring(e.length - p / 2 - 1),
      ref: v
    };
  }, [e, p]);
  if (c) {
    var H;
    return H = h(t), /* @__PURE__ */ i.createElement(f, H.cn("SAdvancedModeContainerMiddle", d(d({
      interaction: C
    }, s), I)), /* @__PURE__ */ i.createElement(U.Provider, {
      value: x
    }, _));
  }
  if (a) {
    var V;
    return V = h(t), /* @__PURE__ */ i.createElement(P, V.cn("SContainerMiddle", d({
      interaction: C,
      title: e,
      ref: le(v, g),
      tag: R,
      __excludeProps: ["title"]
    }, s)), /* @__PURE__ */ i.createElement(q, V.cn("SBeginning", {}), x.begining), /* @__PURE__ */ i.createElement(T, V.cn("STail", {}), x.tail));
  }
  return l = h(t), /* @__PURE__ */ i.createElement(P, l.cn("SContainerMiddle", d(d({}, y), {}, {
    ref: n ?? m
  })), /* @__PURE__ */ i.createElement(q, l.cn("SBeginning", {}), x.begining), /* @__PURE__ */ i.createElement(T, l.cn("STail", {}), x.tail));
}, ve = function(o) {
  var l = arguments[0], t, e = o.styles, a = o.Children, r = R.Trigger, n = i.useContext(U), g = "span", s = "span";
  if (n) {
    var _, c = n.begining, y = n.tail, m = n.ref;
    return _ = h(e), /* @__PURE__ */ i.createElement(r, _.cn("SEllipsis", d({}, F({
      "middle-mod": !0,
      ref: m
    }, l))), /* @__PURE__ */ i.createElement(s, _.cn("SBeginning", {}), c), /* @__PURE__ */ i.createElement(g, _.cn("STail", {}), y));
  }
  return t = h(e), /* @__PURE__ */ i.createElement(r, t.cn("SEllipsis", d({}, F({}, l))), /* @__PURE__ */ i.createElement(a, t.cn("Children", {})));
}, $ = ee(B, {
  Content: ve,
  Popper: R.Popper
});
export {
  $ as default
};
